import React, { useState } from "react";

export const Features = ({ features }) => {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    let truncated = text.substr(0, maxLength);
    return truncated.substr(0, truncated.lastIndexOf(" "));
  };

  return (
    <div id="features" className="text-center py-5 bg-light">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-10 section-title mx-auto mb-4">
            <h2 className="text-4xl font-bold mb-3 text-gray-800">FEATURES</h2>
            <p className="max-w-3xl mx-auto text-muted"
              style={{ color: "#000000" }}>
              Explore the powerful features we offer to streamline your business
              operations and enhance productivity.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="row mt-3 g-4">
          {features.length > 0 ? (
            features.map((item, i) => {
              const desc = item.description || "";
              const isLong = desc.length > 120;
              const isExpanded = expanded[i];

              return (
                <div
                  key={`${item.title}-${i}`}
                  className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
                >
                  <div
                    className="feature-card shadow-sm rounded-3 h-100 d-flex flex-column border-0"
                    style={{ "--bg-img": `url(${item.image})` }}
                  >
                    {/* Content */}
                    <div className="px-3 py-4 flex-grow-1 d-flex flex-column text-center">
                      <h4 className="feature-title fw-semibold mb-3">
                        {item.title}
                      </h4>

                      <p className="feature-description small mb-0">
                        {isExpanded ? desc : truncateText(desc, 120)}
                        {isLong && !isExpanded && "..."}
                      </p>

                      {/* ✅ Read More always below description */}
                      {isLong && (
                        <div className="mt-3">
                          <span
                            className="read-more"
                            onClick={() => toggleExpand(i)}
                          >
                            {isExpanded ? "Show Less" : "Read More"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-muted text-center">Loading features...</p>
          )}
        </div>
      </div>
    </div>
  );
};
